export default __webpack_public_path__ + "static/media/2004-IMcover.ae4b0aab.jpg";